module.exports = __webpack_public_path__ + "static/media/selectedTick.d04d22df.png";